import React, { useEffect, useState } from "react";
import { getAccessToken } from "../../../storage/storage";
import axios from "axios";
import { TableSkelton2 } from "../../../components/Skeletons";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import CompanyModal from "./CompanyModal";

const Company = () => {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [updated, setUpdated] = useState(false);

  // useEffect(() => {
  //   setLoading(true);

  //   axios
  //     .get(`${BASE_URL}/api/companies/`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((response) => {
  //       setData(response.data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching options:", error);
  //       setLoading(false);
  //     });
  // }, [updated]);

  const fetchCompanies = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/api/companies/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCompanies();
  }, [updated]);

  // Function to handle opening the modal and setting selected company
  const handleOpenModal = (company) => {
    setSelectedCompany(company);
    setIsOpenModal(true);
  };

  return (
    <>
      <h1 className="font-semibold text-2xl pb-4 pt-4">Company</h1>
      <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-x-auto w-full">
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-[600px]">
            {/* Table Head */}
            <thead className="bg-[#FFF5CE] text-[#586989] font-medium text-[14px] md:text-[16px]">
              <tr>
                <th className="py-4 px-3 min-w-[150px] text-center">
                  First Name
                </th>
                <th className="py-4 px-3 min-w-[150px] text-center">
                  Company Number
                </th>
                <th className="py-4 px-3 min-w-[150px] text-center">
                  Properties
                </th>
                <th className="py-4 px-3 min-w-[150px] text-center">City</th>
                <th className="py-4 px-3 min-w-[150px] text-center">Country</th>
                <th className="py-4 px-3 min-w-[150px] text-center">Action</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {loading ? (
                <TableSkelton2 />
              ) : data.length > 0 ? (
                data.map((row, index) => (
                  <tr
                    key={index}
                    className="bg-white text-[#1B1E27] border-t border-t-[#DFDFDF] text-[12px] md:text-[16px]"
                  >
                    <td className="px-3 py-4 text-center whitespace-nowrap">
                      {row.name}
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap">
                      {row.company_number}
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap">
                      {row.no_of_properties}
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap">
                      {row.city}
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap">
                      {row.country}
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap">
                      <div
                        className="flex items-center justify-center cursor-pointer"
                        onClick={() => handleOpenModal(row)}
                      >
                        <MdOutlineRemoveRedEye />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center py-16 text-lg font-bold text-[#586989]"
                  >
                    No companies found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pass selectedCompany data to the modal */}
      <CompanyModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        companyData={selectedCompany}
        setUpdated={setUpdated}
        fetchCompanies={fetchCompanies}
      />
    </>
  );
};

export default Company;
